<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,body{
  width: 100vw;

    height: 100%;
    padding: 0px;
    margin: 0upx;
    font-family: PingFang SC;
}

html {
  overflow-y: scroll;
}
 
:root {
  overflow-y: auto;
  overflow-x: hidden;
}
 
:root body {
  position: absolute;
}
 ul,li{
	 padding: 0px;
 }

</style>



// WEBPACK FOOTER //
// src/App.vue